import { render, staticRenderFns } from "./ViewClientsProvider.vue?vue&type=template&id=63246457&"
import script from "./ViewClientsProvider.vue?vue&type=script&lang=js&"
export * from "./ViewClientsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports